var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 11C0.75 12.2426 1.75736 13.25 3 13.25H9.24853C9.55131 13.25 9.8438 13.1401 10.0717 12.9407L12.8231 10.5332C13.0944 10.2958 13.25 9.95292 13.25 9.59246V3C13.25 1.75736 12.2426 0.75 11 0.75H3C1.75736 0.75 0.75 1.75736 0.75 3V11Z",
    stroke: "#BABFC9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5L7 9.5L10 6.5",
    stroke: "#BABFC9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/checkBox.77342709b74e7d86438ac8f9e0b1bb32.svg";
export { ForwardRef as ReactComponent };